import {createAction} from 'redux-act';

export const resetSearchSuggest = createAction('locationsHistory/resetSearchSuggest');
